module.exports = __webpack_public_path__ + "img/u1810.32b0e6ca.svg";